import { useFormikContext } from 'formik';
import { useState } from 'react';

import { TimeWindowPickerInputGroup } from '@/react/portainer/environments/common/TimeWindowPicker/TimeWindowPickerInputGroup';

import { SwitchField } from '@@/form-components/SwitchField';
import { FormSection } from '@@/form-components/FormSection';

import { DockerSetupFormValues } from './types';

export function TimeWindowSection() {
  const { values, setFieldValue } = useFormikContext<DockerSetupFormValues>();
  // Timezone state for change window configuration
  const [timeZone, setTimeZone] = useState('UTC');

  return (
    <FormSection title="Change window settings">
      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={values.changeWindow.Enabled}
            onChange={(value) =>
              setFieldValue('changeWindow', {
                ...values.changeWindow,
                Enabled: value,
              })
            }
            label="Enable Change Window"
            tooltip="GitOps updates to stacks or applications outside the defined change window will not occur."
            labelClass="col-sm-7 col-lg-4"
            data-cy="enable-change-window-switch"
          />
        </div>
      </div>

      {values.changeWindow.Enabled && (
        <>
          <div className="form-group">
            <div className="col-sm-12">
              <TimeWindowPickerInputGroup
                values={values.changeWindow}
                onChangeTimeZone={setTimeZone}
                onChangeChangeWindow={(changeWindow) =>
                  setFieldValue('changeWindow', changeWindow)
                }
                timeZone={timeZone}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-12">
              <span className="text-warning small flex gap-1 align-top">
                <div className="icon icon-sm">
                  <i className="fa fa-exclamation-triangle" />
                </div>
                <div>
                  GitOps updates to stacks or applications outside the defined
                  change window will not occur.
                </div>
              </span>
            </div>
          </div>
        </>
      )}
    </FormSection>
  );
}
